var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-container"},[_c('a-tabs',{attrs:{"type":"card"},on:{"change":_vm.tabChange}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"Данные дилера"}},[_c('ClientData')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }